<template>
    <div class="MultiFieldCriterion">
        <div class="MultiFieldCriterion__endorsement">
            <span v-if="showCriterionIndex" class="MultiFieldCriterion__criterionIndex" :class="additionalIndexClass">
                {{ index }}
            </span>
            <div class="MultiFieldCriterion__body">
                <div class="MultiFieldCriterion__header">
                    <span class="MultiFieldCriterion__headerName">
                        {{ criterion.name }}
                    </span>
                    <EvaluationError
                        v-if="criterion.evaluationError"
                        :evaluation-error="criterion.evaluationError"
                        v-bind="$attrs"
                    />
                </div>
                <MultiFieldCriterionRecords
                    v-for="(fieldKey, fieldIndex) in renderingList"
                    :key="fieldKey"
                    :name="criterion.fields[fieldKey].name"
                    :value="criterion.fields[fieldKey].value"
                    :coverage-type="criterion.fields[fieldKey].coverageType"
                    :requirement-coverage-type="requirementCoverageType"
                    :currency="criterion.fields[fieldKey].currency"
                    :index="fieldIndex"
                    :show-index="showFieldIndex"
                    :additional-index-class="[additionalIndexClass]"
                />
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';

    import difference from 'lodash/difference';
    import startCase from 'lodash/startCase';

    import EvaluationError from '@/modules/entity-details/components/EvaluationError/EvaluationError.vue';
    import { EntityMultiFieldCriterion } from '@/modules/entity-details/types';

    import MultiFieldCriterionRecords
        from './sub-components/MultiFieldCriterionRecords.vue';

    export default defineComponent({
        name: 'MultiFieldCriterion',
        components: {
            EvaluationError,
            MultiFieldCriterionRecords,
        },
        props: {
            criterion: {
                type: Object as PropType<EntityMultiFieldCriterion>,
                default: (): EntityMultiFieldCriterion => ({}) as EntityMultiFieldCriterion,
            },
            index: {
                type: Number as PropType<number>,
                default: 1,
            },
            fieldOrderList: {
                type: Array as PropType<string[]>,
                default: (): string[] => [],
            },
            showCriterionIndex: {
                type: Boolean as PropType<boolean>,
                default: true,
            },
            showFieldIndex: {
                type: Boolean as PropType<Boolean>,
                default: false,
            },
            requirementCoverageType: {
                type: String as PropType<string>,
                default: '',
            },
        },
        computed: {
            defaultFieldsList(): string[] {
                return Object.keys(this.criterion.fields);
            },
            renderingList(): string[] {
                const orderedKeys = this.fieldOrderList.flatMap((name) => this.defaultFieldsList
                    .filter((key) => this.criterion.fields[key].name === name));
                return [ ...orderedKeys, ...difference(this.defaultFieldsList, orderedKeys) ];
            },
            additionalIndexClass(): string | null {
                if (!this.criterion?.evaluationError) {
                    return null;
                }
                return this.criterion.evaluationError.complianceStatusMetadata.length > 0
                    ? 'MultiFieldCriterion--exception'
                    : 'MultiFieldCriterion--error';
            },
        },
        methods: {
            getFieldValue(value: unknown): unknown {
                if (Array.isArray(value)) {
                    return value.join(', ');
                }

                return value;
            },
            startCase,
        },
    });
</script>
